import { computed } from 'vue'
import { useRuntimeConfig } from '#imports'
import { useCountries } from '@shopware/composables'

// Markets (by country ISO) where only private customers are allowed — the
// business/commercial account option is hidden entirely on these saleschannels.
const PRIVATE_ONLY_MARKET_ISOS = ['NO']

/**
 * Whether the current saleschannel's market allows business (commercial)
 * customer accounts. Norway (NO) is private-only.
 */
export function useBusinessAccount () {
    const config = useRuntimeConfig().public
    const { getCountries } = useCountries()

    const businessAccountAllowed = computed(() => {
        const marketCountry = getCountries.value?.find(country => country.id === config.platformDefaults.countryId)
        return marketCountry?.iso == null || !PRIVATE_ONLY_MARKET_ISOS.includes(marketCountry.iso)
    })

    return { businessAccountAllowed }
}
